import { VApp } from 'vuetify/lib/components/VApp';
import { VScaleTransition } from 'vuetify/lib/components/transitions';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{staticClass:"layout__auth--background",attrs:{"dark":_vm.isDarkTheme}},[_c(VScaleTransition,{attrs:{"origin":"center center"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }